<template>
	<modal
		class="table-input-order-modal"
		size="medium"
		v-if="show"
		@close="close">
		<div slot="header">
			<h3><b>{{ $t('Input Order') }}</b></h3>
		</div>
		<div slot="body">
			<div class="row">
				<!-- Product -->
				<div class="col-md-6">
					<div class="form-group">
						<label><b>{{ $t('Product') }}</b></label>
						<multiselect
							class="page-header__select orders-products-list multiselect-auto-width form-control"
							v-model="selectedProduct"
							placeholder="Select Product"
							:options="products"
							:show-labels="false"
							:preselect-first="true"
							:allow-empty="false"
							@select="onSelectedProduct"
							track-by="_id"
							label="name">
							<span slot="noResult">{{ $t('No product found') }}</span>
						</multiselect>
					</div>
				</div>
				<!-- Checkout Page -->
				<div class="col-md-6">
					<div class="form-group">
						<label><b>{{ $t('Checkout Page') }}</b> (optional)</label>
						<multiselect
							class="page-header__select orders-forms-list multiselect-auto-width form-control"
							v-model="selectedForm"
							placeholder="Select Checkout Page"
							select-label=""
							selected-label=""
							deselect-label="Remove"
							:options="formsList"
							:show-labels="true"
							:allow-empty="true"
							track-by="_id"
							label="name">
							<!-- :preselect-first="true" -->
							<span slot="noResult">{{ $t('No checkout page found') }}</span>
						</multiselect>
					</div>
				</div>
				<!-- Handled By -->
				<div class="col-md-6" v-if="isOwner || isRoleAdmin">
					<div class="form-group">
						<label><b>{{ $t('Handled By') }}</b> (optional)</label>
						<multiselect
							class="orders-status-list multiselect-auto-width form-control"
							placeholder="Select Customer Service"
							v-model="selectedMember"
							select-label=""
							selected-label=""
							deselect-label="Remove"
							:options="customerServices"
							:show-labels="true"
							:allow-empty="true"
							label="name">
							<span slot="noResult">No CS found</span>
						</multiselect>
					</div>
				</div>
				<!-- Contacts -->
				<div class="col-md-6">
					<div class="form-group">
						<label><b>Contact</b> (optional)</label>
						<multiselect
							class="orders-status-list multiselect-auto-width form-control"
							placeholder="Select Contact"
							v-model="selectedContact"
							select-label=""
							selected-label=""
							deselect-label="Remove"
							label="name"
							:options="contacts"
							:loading="isFetchingContacts"
							:show-labels="true"
							:allow-empty="true"
							:show-no-results="true"
							@select="selectContact"
							@search-change="doSearchContacts">
							<!--
								:clear-on-select="true"
								:close-on-select="true"
								:internal-search="false"
								select-label=""
								selected-label=""
							-->
							<span slot="caret"></span>
							<span slot="noOptions">Ketikan nama kontak</span>
							<span slot="noResult">Kontak tidak ditemukan</span>
						</multiselect>
					</div>
				</div>
				<!-- Smart Shipping -->
				<div
					class="col-md-6">
					<div class="form-group">
						<label class="text-bold">
							{{ $t('Smart Logistic') }}
						</label>
						<checkbox-toggle
							:label="$t('Turn Off Smart Logistic')"
							v-model="isDisableSmartShipping"
						/>
					</div>
				</div>
			</div>
		</div>
		<div slot="footer">
			<button
				type="button"
				class="btn btn-light"
				@click="close">
				{{ $t('Close') }}
			</button>
			<a
				:href="orderLink"
				target="_blank"
				class="btn btn-primary"
				v-if="selectedProduct._id">
				{{ $t('Input Order') }}
			</a>
			<button
				type="button"
				class="btn btn-primary disabled"
				v-else>
				{{ $t('Input Order') }}
			</button>
		</div>
	</modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Multiselect from 'vue-multiselect';
import Modal from '@/components/Modal.vue';
import CheckboxToggle from '@/components/CheckboxToggle.vue';
import { duplicateVar, buildQuery } from '@/lib/helper';
import contactsApi from '@/api/contacts';

const defaultProduct = { _id: 0, name: 'All Products' };
const defaultForm = { _id: 0, name: 'Select Checkout Pages' };

export default {
	components: {
		Modal,
		Multiselect,
		CheckboxToggle,
	},
	props: {
		products: {
			type: Array,
			default: () => [],
		},
		show: {
			type: Boolean,
			default: false,
		},
		customerServices: {
			type: Array,
			default: () => [],
		},
		defaultSelectedProduct: {
			type: Object,
			default: () => null,
		},
	},
	data() {
		return {
			selectedProduct: '',
			selectedForm: '',
			selectedMember: '',
			selectedContact: '',
			productId: '',
			formId: '',
			limit: 25,
			sort: 'asc',
			sort_by: 'name',
			customerDetail: null,
			isDisableSmartShipping: false,
		};
	},
	computed: {
		...mapGetters({
			user: 'user',
			isAdmin: 'isAdmin',
			forms: 'submissions/forms',
			contacts: 'submissions/contacts',
			isFetchingContacts: 'submissions/isFetchingContacts',
		}),
		isOwner() {
			return this.user && this.user.role === 'owner';
		},
		isRoleAdmin() {
			return this.user && this.user.role === 'owner_admin';
		},
		formsList() {
			const list = this.forms;
			return list;
		},
		orderLink() {
			const productUrl = this.selectedProduct.url;
			const isAdminOrOwner = this.isRoleAdmin || this.isOwner;
			const belongsTo = this.user ? duplicateVar(this.user._id) : '';
			let params = {};

			if (this.selectedForm && this.selectedForm._id !== 0) {
				params.form = this.selectedForm._id;
			}
			if (isAdminOrOwner) {
				if (this.selectedMember) {
					params.belongs_to = this.selectedMember._id;
				}
			} else {
				params.belongs_to = belongsTo;
			}

			if (this.selectedContact && this.selectedContact.name) {
				params.name = this.selectedContact.name;
			}
			if (this.selectedContact && this.selectedContact.email) {
				params.email = this.selectedContact.email;
			}
			if (this.selectedContact && this.selectedContact.phone) {
				params.phone = this.selectedContact.phone;
			}

			if (this.isDisableSmartShipping) {
				params.smart_logistic = 'off';
			}

			const address = this.customerDetail && this.customerDetail.address && this.customerDetail.address[0] ? this.customerDetail.address[0] : null;
			if (address) {
				const addressParams = {
					// phone: address.phone,
					address: address.address,
					province_id: address.province_id,
					city_id: address.city_id,
					subdistrict_id: address.subdistrict_id,
					subdistrict_name: address.subdistrict_name,
				};
				params = Object.assign({}, params, addressParams);
			}

			const utmSource = 'utm_source=manual';
			const urlSuffix = buildQuery(params);
			const isHasQueries = urlSuffix.length > 0;
			const link = isHasQueries ? `${productUrl}?${urlSuffix}&${utmSource}` : `${productUrl}?${utmSource}`;
			return link;
		},
	},
	created() {},
	methods: {
		...mapActions({
			fetchUser: 'fetchUser',
			getForms: 'submissions/getForms',
			getSubmissionContacts: 'submissions/getSubmissionContacts',
		}),
		close() {
			this.clearfields();
			this.$emit('close');
		},
		fetchForms() {
			const productId = this.selectedProduct._id;
			this.getForms(productId);
		},
		doSearchContacts(query) {
			this.ooDelay(() => {
				if (query !== '') {
					this.fetchContacts(query);
				}
			}, 1000);
		},
		fetchContacts(query) {
			const params = {
				limit: this.limit,
				sort_by: this.sort_by,
				sort: this.sort,
				keyword: query,
			};
			this.getSubmissionContacts(params);
		},
		apply() {
			this.close();
		},
		onSelectedProduct() {
			this.selectedForm = '';
		},
		clearfields() {
			this.selectedProduct = defaultProduct;
			this.selectedForm = defaultForm;
			this.selectedMember = '';
			this.selectedContact = '';
		},
		selectContact(contact) {
			const id = contact._id;
			const callback = (response) => {
				const data = response.data;
				this.customerDetail = data;
			};
			const errCallback = (err) => {
				console.log(err);
			};

			contactsApi.getDetails(id, callback, errCallback);
		},
	},
	watch: {
		selectedProduct() {
			if (this.selectedProduct._id !== 0) {
				this.fetchForms();
			}
		},
		show(show) {
			if (show) {
				if (this.defaultSelectedProduct && this.defaultSelectedProduct !== null) {
					this.selectedProduct = this.defaultSelectedProduct;
				}
			}
		},
	},
};
</script>
